
import { ExternalLink } from "lucide-react";
import MapComponent from "@/components/MapComponent";

interface LocationSectionProps {
  address: string;
  latitude?: number;
  longitude?: number;
}

const LocationSection = ({ address, latitude, longitude }: LocationSectionProps) => {
  const generateGoogleMapsUrl = (address: string) => {
    const encodedAddress = encodeURIComponent(address);
    return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-4 sm:p-6">
      <h2 className="text-lg sm:text-xl font-semibold mb-4">Location</h2>
      <div className="mb-4">
        <p className="text-gray-700 font-medium text-sm sm:text-base">{address}</p>
        {address ? (
          <a 
            href={generateGoogleMapsUrl(address)}
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-1 text-blue-600 hover:text-blue-800 text-xs sm:text-sm transition-colors"
          >
            <span>Get directions</span>
            <ExternalLink className="h-3 w-3" />
          </a>
        ) : (
          <p className="text-gray-400 text-xs sm:text-sm">Address not available</p>
        )}
      </div>
      <div className="h-48 sm:h-64 rounded-lg overflow-hidden">
        <MapComponent 
          address={address || ""} 
          latitude={latitude}
          longitude={longitude}
        />
      </div>
    </div>
  );
};

export default LocationSection;
